import { Component, OnInit } from '@angular/core';
import { AuthService} from '../../services/auth.service';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: 'user', title: 'Nastavení',  icon:'fa fa-trash-o', class: '' }
];

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  menuItems: any[];
  day: number = 0;
  dayNameIndex: number = 0;
  month: number = 0;

  days = ["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"];
  months = ["ledna","února","března","dubna","května","června","července","srpna","září","října","listopadu","prosince"];

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.day = new Date().getDate();
    this.dayNameIndex = new Date().getDay();
    this.month = new Date().getUTCMonth();

  }

}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts